import React, {Component, CSSProperties} from 'react'
import classNames from 'classnames'
import cxs from 'cxs/component'
import {Bar, Line, HorizontalBar, Pie, Doughnut} from 'react-chartjs-2'
import {
  Badge,
  Button,
  ButtonDropdown,
  ButtonGroup,
  ButtonToolbar,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Progress,
  Row,
  Table
} from 'reactstrap'
import {BootstrapTable, ExportCSVButton, TableHeaderColumn} from 'react-bootstrap-table'
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css'

import theme from '../../Theme'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {loading} from '../../elements/Loading'
import {IResult} from './Store'
import any = jasmine.any
import {round, toDate, toRound} from '../../helpers/Format'
import {T, TT} from 'helpers/i18n'
import {Modal} from '../../components'
import {DatePicker} from '../../elements'

const resuelveChart = (data: IResult) => {
  const operarios: string[] = Object.keys(data.operarios)
  console.log('DasboardTicket - resuelveChart operarios: ', operarios)
  const sales = operarios.map(value => round(data.operarios[value].sales) )
  console.log('DasboardTicket - resuelveChart - sales: ', sales)
  const tickets = operarios.map(value => data.operarios[value].tickets)
  console.log('DasboardTicket - resuelveChart - tickets: ', tickets)
  const checkins = operarios.map(value => data.operarios[value].checkins)
  console.log('DasboardTicket - resuelveChart checkins: ', checkins)
  return {
    label: operarios,
    sales,
    tickets,
    checkins
  }
}

const resuelveTable = (data: IResult) => {
  const result = resuelveChart(data)
  const table = []
  for(let i=0; i< result.label.length; i++) {
    let temp: any = {}
    temp.username = result.label[i]
    temp.ventas = round(result.sales[i], 2)
    temp.tickets = result.tickets[i]
    temp.checkins = result.checkins[i]
    table.push(temp)
  }
  return table
}

interface Props {
  store?: Store
  result: IResult
}

interface State {
  innerWidth: number
  radioSelected: string
  result: IResult
  from: Date
  to: Date
  datesVisible: boolean
  fromVisible: boolean
  toVisible: boolean
}

const Range = {
  Custom: 'custom',
  Today: 'day',
  Week: 'week',
  Month: 'month',
  Year: 'year'
}

@inject('store')
@loading<Props>(props => [
  props.store!.dashboardTicket.salesReport(Range.Today).then(result => ({result}))
])
@observer
class DashboardTicket extends Component<Props, State> {
  state = {
    innerWidth: window.innerWidth,
    radioSelected: Range.Today,
    result: this.props.store!.dashboardTicket.result,
    from: undefined,
    to: undefined,
    datesVisible: false,
    fromVisible: false,
    toVisible: false,
  }
  constructor(props) {
    super(props)
    console.log('DasboardTicket - constructor')

    // this.state.result = this.props.result
    this.onRadioBtnClick = this.onRadioBtnClick.bind(this)
    const inicioDia = new Date()
    inicioDia.setHours(0,0,0,0)
    const finDia = new Date()
    finDia.setHours(23,59,59,999)
    this.state.from = inicioDia
    this.state.to = finDia
  }

  componentDidMount() {
    console.log('DasboardTicket - componentDidMount')
    this.onHandleResize.call(this)
    window.addEventListener('resize', this.onHandleResize.bind(this))
    // this.setState({result: this.props.result})
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onHandleResize.bind(this))
  }

  onHandleResize() {
    // const isMobile = window.matchMedia('(max-width: 720px)').matches ? true : false
    this.setState({innerWidth: window.innerWidth})
  }

  getResult(radioSelected: string, from?: Date, to?: Date) {
    console.log('DasboardTicket - getResult')
    this.props.store!.dashboardTicket.salesReport(radioSelected, from, to)/*.then(value => {
      this.setState({result: value})
    })*/
  }

  onRadioBtnClick(radioSelected) {
    this.setState({
      radioSelected: radioSelected
    }, () => {
      if (radioSelected === Range.Custom) {
        this.getResult(radioSelected, this.state.from, this.state.to)
      } else {
        this.getResult(radioSelected)
      }
    })
  }

  private toggleFromModal = () =>
    this.setState({radioSelected: Range.Custom, fromVisible: !this.state.fromVisible})

  private toggleToModal = () =>
    this.setState({radioSelected: Range.Custom, toVisible: !this.state.toVisible})

  private handleFromChange = (_, from) => {
    // this.toggleFromModal()
    this.setState({from}, () => this.getResult(this.state.radioSelected, this.state.from, this.state.to))
  }

  private handleToChange = (_, to) => {
    // this.toggleToModal()
    this.setState({to}, () => this.getResult(this.state.radioSelected, this.state.from, this.state.to))
  }

  private handleFromKeyPress = (keyCode: number) => {
    if (keyCode === 13)
      this.toggleFromModal()
  }
  private handleToKeyPress = (keyCode: number) => {
    if (keyCode === 13)
      this.toggleToModal()
  }

  render() {
    // console.log('DasboardTicket - render - radioSelected: ', this.state.radioSelected)
    const {from, to, datesVisible, fromVisible, toVisible} = this.state

    const innerWidth = this.state.innerWidth
    const {result} = this.props.store!.dashboardTicket
    // console.log('render - result: ', result)
    // console.log('render - result.operarios: ', result.operarios)
    const resueltoChart = resuelveChart(result)
    // console.log('resuelto: ', resueltoChart)

    const sales = toRound(result.total.sales)
    const {tickets} = result.total
    const {checkins} = result.total

    const fechas = toDate(from) === toDate(to)? toDate(from): `${toDate(from)} - ${toDate(to)}`

    const title = this.state.radioSelected !== 'custom'? TT(this.state.radioSelected): fechas

    const salesChart = {
      labels: resueltoChart.label,
      datasets: [
        {
          label: 'Ventas',
          data: resueltoChart.sales
        }
      ]
    }
    const ticketsChart = {
      labels: resueltoChart.label,
      datasets: [
        {
          label: 'tickets',
          data: resueltoChart.tickets
        }
      ]
    }
    const checkinsChart = {
      labels: resueltoChart.label,
      datasets: [
        {
          label: 'checkins',
          data: resueltoChart.checkins
        }
      ]}
    console.log('sales: ', salesChart)

    const table = resuelveTable(result)
    return (
      <div className="animated fadeIn container" style={{
        overflow: 'visible',
        maxWidth: innerWidth < 576 ? (innerWidth - 25) + 'px' : undefined
      }}
      >{fromVisible && (
        <Modal title={T('from')}>
          <DatePicker
            withTime
            name={'from'}
            date={from}
            onChange={this.handleFromChange}
            onKeyPress={this.handleFromKeyPress}
          />
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            border: 'none'
          }} >
            <Button style={{backgroundColor: theme.color.background}} onClick={this.toggleFromModal}>{'OK'}</Button>
          </div>
        </Modal>
      )}
        {toVisible && (
          <Modal title={T('to')}>
            <DatePicker withTime name={'to'} date={to} onChange={this.handleToChange}
                        onKeyPress={this.handleToKeyPress}
            />
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}>
              <Button style={{backgroundColor: theme.color.background}} onClick={this.toggleToModal}>{'OK'}</Button>
            </div>
          </Modal>
        )}
        <Row className="mt-1 mb-4">
          <div className="col-12">
            <ButtonToolbar className="float-right" aria-label="Toolbar with button groups">
              <Header className="mr-5">
                {T('from') + ': '}
                <Button onClick={this.toggleFromModal}>{toDate(from)}</Button>
                {T('to') + ': '}
                <Button onClick={this.toggleToModal}>{toDate(to)}</Button>
              </Header>
              <ButtonGroup className="mr-3" aria-label="First group">
                <Button
                  outline
                  style={{
                    color: this.state.radioSelected === Range.Custom ? theme.color.primary : theme.color.secondary
                  }}
                  color="secondary"
                  onClick={() => this.onRadioBtnClick(Range.Custom)}
                >{T(Range.Custom)}</Button>
                <Button
                  outline
                  style={{
                    color: this.state.radioSelected === Range.Today ? theme.color.primary : theme.color.secondary
                    /*background: this.state.radioSelected === Range.Today ? theme.color.hairline : undefined*/
                  }}
                  color="secondary"
                  onClick={() => this.onRadioBtnClick(Range.Today)}
                >{T(Range.Today)}</Button>
                <Button
                  style={{
                    color: this.state.radioSelected === Range.Week ? theme.color.primary : theme.color.secondary
                    /*background: this.state.radioSelected === Range.Week ? theme.color.hairline : undefined*/
                  }}
                  color="outline-secondary"
                  onClick={() => this.onRadioBtnClick(Range.Week)}
                >
                  {T('week')}
                </Button>
                <Button
                  style={{
                    color: this.state.radioSelected === Range.Month ? theme.color.primary : theme.color.secondary
                    /*background: this.state.radioSelected === Range.Month ? theme.color.hairline : undefined*/
                  }}
                  color="outline-secondary"
                  onClick={() => this.onRadioBtnClick(Range.Month)}
                  /*active={this.state.radioSelected === 3}*/
                >
                  {T('month')}
                </Button>
                <Button
                  style={{
                    color: this.state.radioSelected === Range.Year ? theme.color.primary : theme.color.secondary
                    /*background: this.state.radioSelected === Range.Year ? theme.color.hairline : undefined*/
                  }}
                  color="outline-secondary"
                  onClick={() => this.onRadioBtnClick(Range.Year)}
                  /*active={this.state.radioSelected === 4}*/
                >
                  {T('year')}
                </Button>
              </ButtonGroup>
            </ButtonToolbar>
          </div>
        </Row>
        <Row className="mr-1 ml-1">
          <div className="col-12 col-md-4 col-lg-4">
            <Card style={styleCuadroCard}>
              <CardBody className="pb-0">
                <div className="text-value">{title}</div>
              </CardBody>
              <CardBody className="pb-0">
                <div className="text-value">{sales}</div>
                <div>€</div>
                {/*<div className="chart-wrapper mt-3" style={{ height: '70px' }}>
                  <Line data={cardChartData2} options={cardChartOpts2} height={70} />
                </div>*/}
              </CardBody>
            </Card>
          </div>

          <div className="col-12 col-md-4 col-lg-4">
            <Card style={styleCuadroCard}>
              <CardBody className="pb-0">
                <div className="text-value">{title}</div>
              </CardBody>
              <CardBody className="pb-0">
                <div className="text-value">{tickets}</div>
                <div>Tickets</div>
              </CardBody>
            </Card>
          </div>

          <div className="col-12 col-md-4 col-lg-4">
            <Card style={styleCuadroCard}>
              <CardBody className="pb-0">
                <div className="text-value">{title}</div>
              </CardBody>
              <CardBody className="pb-0">
                <div className="text-value">{checkins}</div>
                <div>Checkins</div>
              </CardBody>
            </Card>
          </div>
        </Row>

        <Row className="mr-1 ml-1 justify-content-center">
          <div className={classNames('col-12')}>
            <Card>
              <CardBody>
                <Row>
                  <div className="col-12">
                    <CardTitle className="mb-0">Ventas</CardTitle>
                    <div className="small text-muted">{T('day')}</div>
                  </div>
                </Row>
                <Row>
                  <Col>
                    <Styled>
                      <div
                        style={styleChartF(salesChart.labels.length, innerWidth)}>
                        <Bar data={salesChart} options={cardChartOpts4} height={300}/>
                      </div>
                    </Styled>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Styled>
                      <div
                        style={styleChartF(ticketsChart.labels.length, innerWidth)}>
                        <Bar data={ticketsChart} options={cardChartOpts4} height={300}/>
                      </div>
                    </Styled>
                  </Col>
                </Row>
                <Row>
                  <div className="col-12">
                    <Styled>
                      <div
                        style={styleChartF(checkinsChart.labels.length, innerWidth)}
                      >
                        <Bar data={checkinsChart} options={cardChartOpts4}/>
                      </div>
                    </Styled>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </div>
        </Row>

        <Row className="mr-1 ml-1">
          <div className="col-12 col-sm-12">
            <Card>
              <CardBody>
                <Row className="mb-1">
                  <div className="col-12 col-sm-12">
                    <CardTitle className="mb-1">Ventas</CardTitle>
                    <div className="small text-muted mt-1">{T('day')}</div>
                  </div>
                </Row>
                <BootstrapTable exportCSV={true} data={table} version="4" striped hover pagination search
                                options={tableOptions}>
                  <TableHeaderColumn dataField="username" dataSort isKey>Username</TableHeaderColumn>
                  <TableHeaderColumn dataField="ventas" dataSort>Ventas</TableHeaderColumn>
                  <TableHeaderColumn dataField="tickets" dataSort>Tickets</TableHeaderColumn>
                  <TableHeaderColumn dataField="checkins" dataSort>Checkins</TableHeaderColumn>
                </BootstrapTable>
              </CardBody>
            </Card>
          </div>
        </Row>
      </div>
    )
  }
}

const cardChartOpts4 = {
  tooltips: {
    yAlign: 'bottom',
    enabled: true,
    responsive: true
    /*custom: CustomTooltips,*/
  },
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'left'
  },
  elements: {
    rectangle: {
      backgroundColor: theme.color.hairline,
      borderColor: theme.color.secondary,
      borderWidth: 0.5
    }
  },
  layout: {
    padding: {
      top: 100
    }
  },
  scales: {
    xAxes: [
      {
        display: true,
        barPercentage: '1.1',
        gridLines: {
          color: theme.color.hairline,
          zeroLineColor: 'transparent'
        },
        ticks: {
          fontSize: 12,
          fontColor: theme.color.secondary,
          fontFamily: 'Lato'
        }
      }],
    yAxes: [
      {
        display: true
      }]
  }
}

const tableOptions = {
  sortIndicator: true,
  hideSizePerPage: true,
  paginationSize: 3,
  hidePageListOnlyOnePage: true,
  clearSearch: false,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
  exportCSVBtn: this.createCustomExportCSVButton
}
const styleCuadroCard = {
  background: theme.color.hairline, height: '150px', color: theme.color.secondary
}

const styleChartF = (numero: number, innerWidth: number) => {
  // console.error('numero', numero)
  // console.error('innerWidth', innerWidth)
  let result
  let factor = 24
  if (innerWidth < 768) {
    factor = 8
  }/* else if (innerWidth < 992) {
    factor = 24
  } else if (innerWidth < 1200) {
    factor = 32
  }*/
  // console.error('factor', factor)
  if (numero > factor) {
    result = (Math.trunc(numero * 1000 / 42)) + 'px'
  } else {
    result = '100%'
  }
  // console.error('result', result)
  // console.log('*********************************************************')
  return {
    height: '340px',
    marginTop: '20px',
    overflowX: 'auto',
    paddingTop: '0px',
    width: result,
    background: 'rgba(161,159,161,0.02)'
  } as CSSProperties
}

const styleChart = {
  height: '300px', marginTop: '10px', overflowX: 'auto', paddingTop: '0px', width: '1600%'
} as CSSProperties as CSSProperties

const Styled = cxs('div')({overflow: 'auto'})

const Header = cxs('div')({
  paddingLeft: theme.size.space[1],
} as CSSProperties)

export default DashboardTicket



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/DashboardTicket/index.tsx